import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Observable, Subscription } from 'rxjs';
import { AbstractAuditDto, AbstractDto, AuditViewDto, ResultListDto, RolePermissionEnum, SearchResultMsisdnDto } from '../../service/dto';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { Location } from '@angular/common';
import { HttpAuditService } from '../../service/http-audit.service';
import { faCheck, faExpand, faHourglass, faNotdef, faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'app-subscriber-sim-view',
	templateUrl: './subscriber-sim-view.component.html',
	styleUrl: './subscriber-sim-view.component.scss',
	standalone: false
})
export class SubscriberSimViewComponent implements OnInit, OnDestroy {
	private subscription = new Subscription();
	data?: SearchResultMsisdnDto;
	selectedTabIndex = 0;
	faExpand = faExpand;
	faCheck = faCheck;
	faXmark = faXmark;
	faNotdef = faNotdef;
	faHourglass = faHourglass;


	constructor(private service: HttpSubscriberService, private auditService: HttpAuditService, private activatedRoute: ActivatedRoute, private location: Location) {

	}

	ngOnInit(): void {
		this.subscription = this.activatedRoute.params.subscribe(params => {
			const msisdnId = +params['msisdnId'];
			const personId = +params['personId'];
			this.service.getMsisdn(msisdnId, personId).subscribe({
				next: data => this.data = data,
				error: err => console.error('Failed to load msisdn', err)
			});
		});
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	getGivenNames(): string {
		if (!this.data) {
			return '';
		}
		let out = '';
		let seperator = '';
		if (this.data.document.firstName) {
			out += seperator + this.data.document.firstName;
			seperator = ' ';
		}
		if (this.data.document.secondName) {
			out += seperator + this.data.document.secondName;
			seperator = ' ';
		}
		if (this.data.document.otherNames) {
			out += seperator + this.data.document.otherNames;
			seperator = ' ';
		}
		return out;
	}

	trackByHashCode(index: number, item: AbstractDto): any {
		return item.hashCode;
	}
	goBack() {
		this.location.back();
	}
	fetchAudits = (page: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> => {
		return this.auditService.getViewHistoryOfMsisdn(this.data!.person.id, this.data!.msisdn.id, page, pageSize);
	}
}
